import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "doctor",
    serviceName: "graphql",
    query: gql`
      query doctor($ids: [String]) {
        doctor(ids: $ids) {
          total
          data {
            id
            lat
            lng
            address
            site_url
            is_active
            tellphone
            postal_code
            check_messages
            register_date
            registered_number
            national_identifier
            specialist
            medical_number
            status {
              id
              title
            }
            city {
              title
              state {
                title
              }
            }
            media {
              id
              full_url
              collection_name
            }
          }
        }
      }
    `,
  },
};

export default schema;
